'use strict';

var Constants = require('../constants/constants');

// Constructor
var Carousel = function() {

  var self = this;

  self.config = {
    'carousel'       :  $('[data-carousel]'),
    'slide'          :  $('[data-carousel-slide]'),
    'slickSettings'  :  {
      arrows: false,
      dots: true,
      dotsClass: 'carousel__dots',
      easing: 'ease',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: parseInt(new Constants().MEDIA_QUERIES.MEDIUM.match(/\d+/)[0]),
          settings: {
            swipe: false,
            draggable: false,
            arrows: true,
            prevArrow: '<button type="button" class="carousel__arrow -left"><span class="icon icon--carousel-prev"></span></button>',
            nextArrow: '<button type="button" class="carousel__arrow -right"><span class="icon icon--carousel-next"></span></button>'
          }
        }
      ]
    },
    'fadeOnSlide'   :  $('[data-fade-on-slide]')
  }

  var $carousel      =  self.config.carousel;
  var $slide         =  self.config.slide;
  var slickSettings  =  self.config.slickSettings;
  var $fadeOnSlide   =  self.config.fadeOnSlide;

  self.initCarousel = function() {

    if ($carousel.attr('data-autoplay') === 'true') {
      slickSettings.autoplay = true;
    }

    $carousel.slick(slickSettings);
    self.fadeOnSlide();
  }

  self.fadeOnSlide = function() {

    $fadeOnSlide.addClass('is-visible');

    $carousel.on('afterChange', function() {
      $fadeOnSlide.addClass('is-visible');
    });

    $carousel.on('beforeChange', function() {
      $fadeOnSlide.removeClass('is-visible');
    });
  }

  self.init = function() {

    if ($slide.length > 1) {
      self.initCarousel();
    }
  }
};

module.exports = Carousel;
